import React from "react";
import ReactDOM from "react-dom/client";
import App from "./app";

let currentReactRoot: ReactDOM.Root | null = null;

export function initReact(rootElement: HTMLElement | null = null) {
    if (!rootElement) {
        throw new Error("Failed to find the root element");
    }

    currentReactRoot = currentReactRoot ?? ReactDOM.createRoot(rootElement);
    currentReactRoot.render(
        <React.StrictMode>
            <App />
        </React.StrictMode>
    );
}

export function cleanupReact() {
    if (currentReactRoot) {
        currentReactRoot.unmount();
        currentReactRoot = null;
    }
}